<template>
  <header :class="{ 'bd-banner-navbar': isBannerEnabled }" class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
    <router-link class="navbar-brand mr-0 mr-md-2 custom-brand" to="/" aria-label="calibrate">
      <img src="~@/assets/images/Opus_IVS_90h_extrawhite.png" alt="calibrate" style="height: 48px" />
      <span class="custom-app-title">Calibrate Copilot&trade;</span>
    </router-link>

    <div class="navbar-nav-scroll">
      <ul class="navbar-nav bd-navbar-nav flex-row">
        <li class="nav-item" v-for="n of nav" :key="n.name">
          <router-link exact class="nav-link" v-if="isAllowed(n.url)" :to="n.url" title="n.name">{{ n.name }}</router-link>
        </li>
      </ul>
    </div>

    <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
      <li v-if="profile.username" class="nav-item">
        <a id="profile" href="#" @click="showProfile" class="nav-link" title="profile">
          <i class="fas fa-user pr-1"></i>
          {{ username }}
        </a>
      </li>
      <li class="nav-item">
        <a id="logout" href="#" @click="logout" class="nav-link" title="logout">
          <i class="fas fa-sign-out-alt"></i>
          Logout
        </a>
      </li>
    </ul>
    <service-hub />
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ServiceHub from '@/components/admin/service-hub'
export default {
  name: 'nav-top',
  components: {
    ServiceHub
  },
  data() {
    return {
      nav: []
    }
  },
  mounted() {
    this.initMenu()
  },
  computed: {
    ...mapGetters('auth', ['profile', 'isAllowed']),
    isShop() {
      let _is = false
      if (this.profile.roles[0] === 4 || this.profile.roles[0] === 5) {
        _is = true
      }
      return _is
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    username: {
      get() {
        let user = ''
        if (this.profile !== undefined && this.profile !== null) {
          user = this.profile.username
        }
        return user
      }
    }
  },
  methods: {
    ...mapActions('chat', ['quitChat']),
    ...mapActions('auth', ['clearToken']),
    initMenu() {
      this.nav = []
      // this.nav = [
      //   { url: '/schedule', name: this.isShop ? 'Schedule' : 'Incoming' },
      //   { url: '/calibrates', name: 'Calibrate ROs' },
      //   { url: '/dashboard', name: 'Dashboard' }
      // ]
    },
    showProfile() {
      this.$emit('showProfile')
    },
    logout() {
      this.quitChat()
      this.clearToken()
      window.location.assign('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-brand {
  position: relative;
  background: #fff;
  padding: 5px;
}
.custom-app-title {
  position: absolute;
  bottom: 2px;
  left: 52px;
  color: #000;
  font-size: 0.7em;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/nav-top.vue